<template>
  <div>
    <v-tabs color="secondary" dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab @click="way='money'">&nbsp; &nbsp;Money Transfer - IMPS</v-tab>
      <v-tab @click="way='report'">&nbsp; &nbsp;DMR Transaction Report</v-tab>
    </v-tabs>
    <MoneyTransfer v-show="way === 'money'"></MoneyTransfer>
    <DMRReport v-show="way === 'report'"></DMRReport>
  </div>
</template>
<script>
import MoneyTransfer from "../dmr/MoneyTransfer";
import DMRReport from "../dmr/DMRReport";
export default {
  data() {
    return {
      way: "money"
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    dmr() {
      return this.$store.getters.dmr;
    },
    dmrenable() {
      return this.$store.getters.dmrenable;
    }
  },
  watch: {
    user(value) {
      let vm = this;
      if (vm.user.length == 0) {
        this.$router.push("/account");
      }
    }
  },

  components: {
    MoneyTransfer,
    DMRReport
  },
  mounted() {
    let vm = this;
    if (vm.user.length == 0) {
      this.$router.push("/account");
    }
    if (!vm.dmrenable) {
      this.$router.push("/account");
      return;
    }
    vm.$store.commit("setdmr", null);
  }
};
</script>
